<style>
  .fontpassword {
  position: relative;
}

.fontpassword span i {
position: absolute;
left: 15px;
top: 40px;
color: gray;
}
</style>
@if (_active) {
  <kendo-window
    title="Reset Password"
    (close)="_active = false;"
    (stateChange)="_onStateChanges($event)"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form -->
    <form novalidate [formGroup]="_form" class="form_style">
      <!-- Row Saves -->
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections margin-top-4">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Reset Password
                  <span class="action-button action-button-viewMode">
                    <div class="action-button-icon">
                      <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                    </div>
                    <div class="edit-icon-text">Edit</div>
                  </span>
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    <li>
                      <button (click)="_onSave()"
                        class="asap-btn"
                        kendoButton>
                        Reset Password
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-12">
                <div class="formsMenuSeparator"></div>
              </div>
            </div>
            <div class="row row_padding">
              <fieldset class="col-12 col-xl-9">
                <label>Email: {{_email}}</label>
                <div>
                  <span class="assemblystyle">
                    <input id="active"
                      type="checkbox"
                      class="k-checkbox"
                      [checked]="hasComplexPassword"
                      [disabled]="true"
                      kendoCheckBox />
                      <label for="ResetPasswordType" class="control-label labelWidth">Complex Password</label>
                    </span>
                  </div>
                  <div class="form-group margTop15 special_style_formgroup">
                    <span class="assemblystyle">
                      <input id="active"
                        type="checkbox"
                        class="k-checkbox"
                        name="ResetPasswordType"
                        formControlName="RequireAutomaticPassword"
                        (click)="OnSelectCheckbox(1)"
                        [value]="1"
                        kendoCheckBox />
                        <label for="ResetPasswordType" class="control-label labelWidth">Automatically create a password</label>
                      </span>
                      @if (_form.get('ResetPasswordType').value == 1 && hasComplexPassword) {
                        <p style="font-size:13px">
                          Passwords must be between 9 and 256 characters and use a combination of the
                          following uppercase letters, lowercase letters, numbers, and symbols.
                        </p>
                      }
                      @if (_form.get('ResetPasswordType').value == 1 && !hasComplexPassword) {
                        <p style="font-size:13px">
                          Password Must include at least 6 characters.
                        </p>
                      }
                    </div>
                    @if (_form.get('ResetPasswordType').value == 1) {
                      <div
                        class="form-group special_style_formgroup" style="display:grid">
                        <label for="Password" class="control-label">Password</label>
                        <div class="input-group mb-3">
                          <input [type]="fieldTextType ? 'text' : 'password'"
                            class="k-textbox writebox newFormControlWidth"
                            formControlName="Password"
                            placeholder="Password" />
                            <div class="input-group-prepend">
                              <span (click)="toggleFieldTextType()">
                                @if (PasswordValidateObject.passwordStrengthDescription && _form.get('Password').value) {
                                  <span [style.color]="PasswordValidateObject.color">
                                    {{PasswordValidateObject.passwordStrengthDescription}}
                                  </span>
                                }
                                <i class="fa"
                         [ngClass]="{
                        'fa-eye-slash': !fieldTextType,
                        'fa-eye': fieldTextType
                      }">
                                </i>
                              </span>
                            </div>
                          </div>
                          @if (_form.get('ResetPasswordType').value == 1 && _form.get('Password').value) {
                            <app-password-strength [hasComplexPassword]="hasComplexPassword" [passwordToCheck]="_form.value.Password" (passwordStrengthObject)="passwordStrengthObject($event)"></app-password-strength>
                          }
                        </div>
                      }
                      <div>
                        <span class="assemblystyle">
                          <input id="active"
                            type="checkbox"
                            class="k-checkbox"
                            name="ResetPasswordType"
                            formControlName="RequireUserChangePassword"
                            (click)="OnSelectCheckbox(2)"
                            [value]="2"
                            kendoCheckBox />
                            <label for="ResetPasswordType" class="control-label labelWidth">Require this user to change their password when they first sign-in</label>
                          </span>
                        </div>
                        <div>
                          <span class="assemblystyle">
                            <input id="active"
                              type="checkbox"
                              class="k-checkbox"
                              name="ResetPasswordType"
                              formControlName="EmailSignInfo"
                              (click)="OnSelectCheckbox(3)"
                              [value]="3"
                              kendoCheckBox />
                              <label for="ResetPasswordType" class="control-label labelWidth">Email the sign-in info to me</label>
                            </span>
                          </div>
                          @if (_form.get('ResetPasswordType').value == 3) {
                            <div
                              class="form-group special_style_formgroup" style="display:grid">
                              <label for="_email" class="control-label">Email</label>
                              <!-- [class.disabled]="_email.value == null" -->
                              <kendo-combobox #Kendo_Combobox_Users
                                [data]="_usersListFiltered"
                                class="bordered newFormControlWidth"
                                [suggest]="true"
                                [filterable]="true"
                                (filterChange)="_handleUsersFilter($event)"
                                [textField]="'userName'"
                                [valueField]="'userName'"
                                [valuePrimitive]="true"
                                formControlName="EmailTo"
                                placeholder="Email">
                              </kendo-combobox>
                            </div>
                          }
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- <asap-dialog-layout
              *ngIf="_isDialiog"
              [data]="_dialogModel"
              [componentName]="_dialogComponentName"
              (closeDialog)="_closeDialog($event)"
              >
            </asap-dialog-layout> -->
          </kendo-window>
        }










